var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_15056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24683 15.332V25.5742H11.0152",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24683 6.81495V2.06547C7.24683 1.24045 7.93063 0.556641 8.75566 0.556641H26.8616C27.6867 0.556641 28.3705 1.24045 28.3705 2.06547V25.575H18.5593",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6756 25.5822H41.9351V21.1449C41.9351 20.6915 41.727 17.8596 41.3628 17.5772L37.4086 15.6447L36.7322 10.9547C36.6579 10.1817 36.0113 9.60938 35.2383 9.60938H28.363V25.5747H32.1314",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9073 29.3512C37.9885 29.3512 39.6756 27.664 39.6756 25.5828C39.6756 23.5016 37.9885 21.8145 35.9073 21.8145C33.8261 21.8145 32.1389 23.5016 32.1389 25.5828C32.1389 27.664 33.8261 29.3512 35.9073 29.3512Z",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7911 29.3512C16.8723 29.3512 18.5594 27.664 18.5594 25.5828C18.5594 23.5016 16.8723 21.8145 14.7911 21.8145C12.7099 21.8145 11.0227 23.5016 11.0227 25.5828C11.0227 27.664 12.7099 29.3512 14.7911 29.3512Z",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75293 15.334H12.4349",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75293 6.81641H12.4349",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.557373 11.0742H13.9362",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_15056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.5,
    height: 29.9091,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truck-icon.e65ef59375305b733d444ce3023bb712.svg";
export { ForwardRef as ReactComponent };